import narasimhaPic from "../Assets/narasimha-pic.jpg";

export const profile = {
  name: "Anguluri Narasimha",
  titles: [
    "Java Backend Developer",
    "Full Stack Developer",
    "AI & Systems Engineer"
  ],
  bio: [
    "Final-year B.Tech CSE student passionate about building secure, scalable, and production-grade backend systems using Java, Spring Boot, and modern cloud technologies.",
    "Experienced in designing REST APIs, implementing Spring Security with JWT, architecting reliable databases in PostgreSQL/MySQL, and building real-world systems used in institutional environments.",
    "Also explore AI engineering with TensorFlow and OpenCV, integrating intelligent capabilities into real applications. I enjoy solving complex problems, writing clean code, and continuously improving as an engineer."
  ],
  image: narasimhaPic, // keep your image import name same as project requires
  social: {
    email: "narasimhaanguluri001@gmail.com",
    linkedin: "https://www.linkedin.com/in/narasimha-anguluri-1b72a12a6",
    github: "https://github.com/Narasimha123001",
    x: "https://x.com", // if you have X profile add, otherwise keep placeholder
  },
};
